import cn from "classnames";
import React, { Component } from "react";

export default class ModalTemplate extends Component {
    initialState = {};

    state = {
        isLoading: true,
    };

    componentDidMount() {
        this.setState({ isLoading: false, ...this.initialState });
    }

    close = (data = false) => {
        const { callback, close } = this.props;
        this.setState({ isLoading: false });
        if (callback) {
            callback(data);
        }
        return close();
    };

    renderHeader = () => {
        const { title, withoutHeader, onClose, withoutCloseButton } = this.props;
        const close = () => {
            onClose?.();
            this.props.close();
        };

        if (withoutHeader) {
            if (withoutCloseButton) {
                return null;
            }
            return (
                <div className="modal-window__close">
                    <div className="close close--sm" onClick={close} />
                </div>
            );
        } else {
            return (
                <div className="modal-window__header">
                    <div className="modal-window__header-title">{this.state.title || title || ""}</div>
                    {!withoutCloseButton && <div className="close close--sm" onClick={close} />}
                </div>
            );
        }
    };

    renderBody = () => {
        const { CustomBody, text, bodyData, add, enums } = this.props;
        return CustomBody ? (
            <CustomBody {...bodyData} add={add} back={this.props.close} close={this.props.close} enums={enums} />
        ) : (
            <div className="modal-window__body">{text}</div>
        );
    };

    renderFooter = () => {
        const { CustomFooter, footerData } = this.props;
        return CustomFooter ? <CustomFooter {...footerData} /> : <div className="modal-window__footer" />;
    };

    calcCname = () => {
        const { windowMod, name } = this.props;
        return cn({
            "modal__window modal-window": true,
            "modal-window--print": name === "print",
            "modal-window--route modal-route": name === "routeSegments",
            [`modal-window--${windowMod}`]: !!windowMod,
        });
    };

    render() {
        const cname = this.calcCname();
        return (
            <div className={cname}>
                {this.renderHeader()}
                {this.renderBody()}
                {this.renderFooter()}
            </div>
        );
    }
}
